module.exports = __webpack_public_path__ + "assets/img/title-184bc378.png";